import { render, staticRenderFns } from "./tableheader-component.vue?vue&type=template&id=ea326d40"
import script from "./tableheader-component.vue?vue&type=script&lang=ts"
export * from "./tableheader-component.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports